/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AttributeVisibility
 */
export interface AttributeVisibility {
    /**
     * 
     * @type {boolean}
     * @memberof AttributeVisibility
     */
    isVisible: boolean;
}

export function AttributeVisibilityFromJSON(json: any): AttributeVisibility {
    return AttributeVisibilityFromJSONTyped(json, false);
}

export function AttributeVisibilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttributeVisibility {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isVisible': json['isVisible'],
    };
}

export function AttributeVisibilityToJSON(value?: AttributeVisibility | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isVisible': value.isVisible,
    };
}


